import { useElements, useStripe } from '@stripe/react-stripe-js';
import { usePrevious } from '@project/utils/hooks/values';
export var ThreeStepsConfirmation = function (_a) {
    var clientSecret = _a.clientSecret, callback = _a.callback;
    var stripe = useStripe();
    var elements = useElements();
    var previousClientSecret = usePrevious(clientSecret);
    if (stripe && elements && !previousClientSecret && clientSecret) {
        if (clientSecret === null || clientSecret === void 0 ? void 0 : clientSecret.startsWith('pi_')) {
            stripe.confirmCardPayment(clientSecret).then(function (result) {
                if ((result === null || result === void 0 ? void 0 : result.paymentIntent) &&
                    result.paymentIntent.status === 'succeeded') {
                    callback && callback();
                }
            });
        }
    }
    return null;
};
export default ThreeStepsConfirmation;
